import { Grid, Text } from '@simplywallst/ui-core';
import { StockAlertSubscription } from './StockAlertSubscription';
import { SystemRestrictionReason } from '@/hooks/useInfiniteCompanyScreenersQuery';

type Props = {
  rules?: string;
  maxResultCountForRecentCompanyFeature?: number | null;
  reason?: SystemRestrictionReason | null;
};

export const NoResultsPanelNewCompanies = ({
  rules,
  maxResultCountForRecentCompanyFeature,
  reason,
}: Props) => {
  const isResultSetTooLarge =
    reason &&
    [
      'RESULT_SET_TOO_LARGE_FOR_ONLY_NEW',
      'RESULT_SET_TOO_LARGE_FOR_IS_NEW',
    ].includes(reason);
  const getReason = () => {
    if (isResultSetTooLarge && maxResultCountForRecentCompanyFeature)
      return `New Stock Detection is only available for a screener with up to ${maxResultCountForRecentCompanyFeature} results. Refine your criteria and save this screener to use new stock alerts.`;

    return 'No new companies found for this screener over the last 7 days. Save this screener to receive alerts when new companies detected.';
  };

  return (
    <Grid
      templateColumns="minmax(auto, 320px)"
      justifyContent="center"
      templateRows="auto auto"
      gap="32px"
      justifyItems="center"
    >
      <Text typography="xSmall" color="textSoft" textAlign="center">
        {getReason()}
      </Text>
      {rules && !isResultSetTooLarge && (
        <StockAlertSubscription rules={rules} />
      )}
    </Grid>
  );
};
